export default "__VITE_ASSET__CRjfpJ9A__"